/** Default UTC date window for operational admin queries (YYYY-MM-DD). */
export function defaultUtcRangeDays(days = 14) {
  const to = new Date();
  const from = new Date();
  from.setUTCDate(from.getUTCDate() - days);
  return { from: from.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) };
}
